module.exports = __webpack_public_path__ + "img/ovkasten_ms.c5013a2e.png";